exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.distincted[data-v-646795e0] {\n    padding: 26px 0 9px;\n    font-weight: bold;\n}\n", ""]);

// exports
